import { render, staticRenderFns } from "./surveyListTab.vue?vue&type=template&id=522f8e51&lang=pug"
import script from "./surveyListTab.vue?vue&type=script&lang=js"
export * from "./surveyListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports